
export default {
  state: {},
  mutations: {
    setMenu(state, payload) {
      if(typeof payload !== 'object') return;
      let data = payload.value || null;
      if(data) {
        const filterMenu = function(menu, rootPath) {
          let len = menu.length;
          let arr = [];
          let sortArr = function (a, b) {
            if(a.sort && b.sort) {
              return (a.sort - b.sort)
            }
          };
          for (let i = 0; i < len; i++) {
            let v = menu[i];
            if(!v.title) continue;
            if(v.path && rootPath) {
              v.path = rootPath + '/' + v.path;
            }
            if(v.component) {
              delete v.component;
            }
            if(v.children && v.children.length) {
              let arr = filterMenu(v.children, v.path);
              v.children = (arr.length) ? arr.sort(sortArr) : [];
            }
            arr.push(v);
          }
          if(arr.length) arr = arr.sort(sortArr);
          return arr;
        }
        if(data.children && data.children.length) {
          data = filterMenu(data.children, data.path);
        }else{
          data = []
        }
      }
      state[payload.key] = Array.isArray(data) ? data : [];
    },
  },
};
